import { IActivityCategory } from '@eventr/common'
import { TEventrIcons } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { cardTranslation } from '../../../i18n/translateHelpers'
import { useBoundStore } from '../../../state/bound.store'
import { RowInfoStandart } from './RowInfoStandart'
import { SectionHeader } from './sectionHeader'
interface ICategoryListProps {
    categories?: string[]
}

export const CategoryList = ({ categories }: ICategoryListProps) => {
    const { activityCategories } = useBoundStore(
        useShallow((s) => {
            return {
                activityCategories: s.orgConfig?.activityCategories ?? [],
            }
        })
    )
    if (!categories || categories.length === 0) {
        return null
    }
    if (!activityCategories || activityCategories.length === 0) return null

    const categoryList: IActivityCategory[] = []
    categories.forEach((cat) => {
        const category = activityCategories.find((c) => c.pub_id === cat)
        if (category) {
            categoryList.push(category)
        }
    })
    if (!categoryList || categoryList.length === 0) return null
    return (
        <Stack spacing={'8px'}>
            <SectionHeader title={cardTranslation('Categories')} />
            {categoryList.map((cat) => {
                return (
                    <RowInfoStandart
                        key={cat.id}
                        middle={cat.name}
                        icon={cat.icon as TEventrIcons}
                        bubbleColour={cat.colour}
                    />
                )
            })}
        </Stack>
    )
}
